// Legacy Forms
// TODO GROW-1719: remove once new forms are live
export const CORPORATE_GIFTING_FORM_ID = 'e33378ea-c111-4735-b028-5db808dbe637';
export const OLD_HEALTHCARE_FORM_ID = '1c640919-9079-4b09-b72b-fb32db826fd6';
export const OLD_RESEARCH_FORM_ID = '57685746-2d57-4c35-b13a-9619db3e0a77';
export const PERFORMANCE_FORM_ID = '118ef6a1-4645-4ed1-9e5f-40d35086c780';
export const WELLNESS_FORM_ID = 'dce1b8ed-0435-41aa-9afc-5bfa8a5af60a';

// Updated Forms
export const CORPORATE_WELLNESS_FORM_ID =
  '1cd2595e-46c4-49e5-85fc-df6b6471c1e7';
export const GIFTING_AND_EVENTS_FORM_ID =
  '14aa4a64-d84e-4104-8a5d-028bbec7edfb';
export const HEALTHCARE_FORM_ID = 'a4272c20-90ac-47dc-bb4a-cc751517631c';
export const MILITARY_FORM_ID = '7f0685b7-a497-4f79-b58f-2829d89b5c76';
export const RESEARCH_FORM_ID = '8d7f3ff8-7443-4d7a-83ae-2a6af4d5f51d';
export const SPORTS_FORM_ID = '8efeecda-217b-45dd-ae13-de2fcc41708c';

export const AMBASSADOR_PROGRAM_FORM_ID = 'ambassador-program';
export const API_INTEGRATION_FORM_ID = 'api-integration';
